import PropTypes from 'prop-types'

const AppBarPropTypes = {
  /** A node for the "actions" available - mainly menu icon available or not at time of the writing */
  actions: PropTypes.node
}

export default AppBarPropTypes
